const trans_ar = {
  subdomain: "النطاق الفرعي",
  store_url_preview: "معاينة رابط المتجر",
  open_store_portal: "فتح بوابة المتجر",
};

export default trans_ar;
